export default __webpack_public_path__ + "8a63b80f7c581bfea04c62c5699cecaa.svg";